import type { CSSProperties, FC } from 'react'

import { ArrowDownRight, ArrowUpRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { cultureIndex } from '@/constants/home'

const Move: FC<{ label: string, change: number }> = ({ label, change }) => {
    const up = change > 0

    return (
        <li className='flex shrink-0 items-center gap-3 border-r border-cream/15 px-6 py-4'>
            <span className='whitespace-nowrap text-[15px] text-cream'>{label}</span>
            <span className={cn('inline-flex items-center gap-1 font-mono text-sm tabular-nums', up ? 'text-ember' : 'text-cream/55')}>
                {up ? <ArrowUpRight className='size-4' /> : <ArrowDownRight className='size-4' />}
                <span className='sr-only'>{up ? 'up' : 'down'}</span>
                {Math.abs(change)}%
            </span>
        </li>
    )
}

export const CultureTicker: FC = () => {
    return (
        <section
            id='culture-index'
            aria-label='Culture index'
            className='ticker relative flex items-stretch overflow-hidden bg-ink text-cream'
        >
            <div className='relative z-10 flex shrink-0 flex-col justify-center gap-1 border-r border-cream/15 bg-ink px-5 py-3 md:px-8'>
                <p className='flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-ember'>
                    <span className='size-1.5 animate-pulse-dot rounded-full bg-ember' />
                    Culture index
                </p>
                <p className='font-serif text-lg italic leading-none text-cream/80'>live-ish</p>
            </div>

            <div className='mask-fade-x min-w-0 flex-1 overflow-hidden'>
                <ul
                    className='ticker-track flex w-max'
                    style={{ '--ticker-duration': '70s' } as CSSProperties}
                >
                    {[...cultureIndex, ...cultureIndex].map((move, index) => (
                        <Move
                            key={`${move.label}-${index}`}
                            label={move.label}
                            change={move.change}
                        />
                    ))}
                </ul>
            </div>
        </section>
    )
}
